import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import { FORM_VIEW } from '../../constants';
import ServiceProviderLocationProvider from './components/ServiceProviderLocationProvider';
import ServiceProviderLocationList from './list/index';

function ServiceProviderLocation({
  serviceProviderId: pageId,
  tabErrors,
  onChange = null,
  action,
  entityId,
  currentIndex,
  spDispatchMethod,
}) {
  const commonProps = {
    serviceProviderId: pageId,
    tabErrors,
    onChange,
    action,
    entityId,
    currentIndex,
    spDispatchMethod,
  };
  const LocationWrapper =
    action === FORM_VIEW.EDIT ? ServiceProviderLocationProvider : Box;
  const LocationWrapperProps =
    action === FORM_VIEW.EDIT ? { pageId, entityId } : {};

  return (
    <LocationWrapper {...LocationWrapperProps}>
      <ServiceProviderLocationList {...commonProps} />
    </LocationWrapper>
  );
}

export default observer(ServiceProviderLocation);
